<template>
    <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-gray-400 gap-4">
            <div v-for="n in 8" :key="n"
            class="hover:shadow-lg rounded-lg animate-pulse border-2 border-gray-900 bg-primary overflow-hidden">
                <div class="h-fit grid w-full  border-transparent">
                <div class="border-transparent items-center gap-4 rounded-t-lg pl-4 pt-4 flex">
                    <div class="flex h-10 w-10 bg-transparent items-center">
                        <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                    <div class="h-2.5 rounded-full bg-gray-700 w-24"></div>
                </div>
                <div class="h-fit px-4 py-5 bg-transparent">
                    <div class="gap-2 grid">
                        <div class="h-2.5 rounded-full bg-gray-700 w-40"></div>
                        <div class="h-2.5 rounded-full bg-gray-700 w-36"></div>
                        <div class="h-2.5 rounded-full bg-gray-700 w-32"></div>
                    </div>
                    <div class="h-3.5 rounded-full bg-gray-700 w-full mt-12"></div>
                </div>
                </div>
            </div> 
        </div> 
</template>